var _clipPath, _g, _clipPath2, _g2, _mask, _g3, _mask2, _mask3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePhotoPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 1600",
    width: 1600,
    height: 1600,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1600,
    x: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,800,800)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(70,131,236)",
    fillOpacity: 1,
    d: " M489.35400390625,0 C489.35400390625,270.26300048828125 270.26300048828125,489.35400390625 0,489.35400390625 C-270.26300048828125,489.35400390625 -489.35400390625,270.26300048828125 -489.35400390625,0 C-489.35400390625,-270.26300048828125 -270.26300048828125,-489.35400390625 0,-489.35400390625 C270.26300048828125,-489.35400390625 489.35400390625,-270.26300048828125 489.35400390625,0z"
  }))))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1600,0 L1600,1600 L0,1600z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_31"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,16.345029830932617,-12.482913970947266)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,722.6810302734375,709.9110107421875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillOpacity: 1,
    d: " M48.17499923706055,21.01300048828125 C48.17499923706055,21.01300048828125 43.275001525878906,-16.360000610351562 11.729999542236328,-29.60300064086914 C-19.815000534057617,-42.84600067138672 -48.17499923706055,-20.660999298095703 -48.17499923706055,-20.660999298095703 C-48.17499923706055,-20.660999298095703 -45.62099838256836,15.958000183105469 -10.684000015258789,29.434999465942383 C24.253000259399414,42.9119987487793 48.17499923706055,21.01300048828125 48.17499923706055,21.01300048828125z"
  }))))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_31_1",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_31"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "__lottie_element_40"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,16.345029830932617,-12.482913970947266)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,862.7329711914062,709.9110107421875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillOpacity: 1,
    d: " M-48.17499923706055,21.01300048828125 C-48.17499923706055,21.01300048828125 -43.275001525878906,-16.360000610351562 -11.729999542236328,-29.60300064086914 C19.815000534057617,-42.84600067138672 48.17499923706055,-20.660999298095703 48.17499923706055,-20.660999298095703 C48.17499923706055,-20.660999298095703 45.62099838256836,15.958000183105469 10.684000015258789,29.434999465942383 C-24.253000259399414,42.9119987487793 -48.17499923706055,21.01300048828125 -48.17499923706055,21.01300048828125z"
  }))))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_40_1",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_40"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_3_1",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#__lottie_element_3"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,800,800)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(70,131,236)",
    fillOpacity: 1,
    d: " M489.35400390625,0 C489.35400390625,270.26300048828125 270.26300048828125,489.35400390625 0,489.35400390625 C-270.26300048828125,489.35400390625 -489.35400390625,270.26300048828125 -489.35400390625,0 C-489.35400390625,-270.26300048828125 -270.26300048828125,-489.35400390625 0,-489.35400390625 C270.26300048828125,-489.35400390625 489.35400390625,-270.26300048828125 489.35400390625,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_3_1)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_7)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,818.7838745117188,894.9895629882812)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,192,68)",
    fillOpacity: 1,
    d: " M-190.80599975585938,316.697998046875 C-190.80599975585938,316.697998046875 -231.24899291992188,-88.322998046875 -212.42100524902344,-246.70799255371094 C-188.23500061035156,-450.1679992675781 101.5,-502.04400634765625 169.27499389648438,-273.1780090332031 C226.552001953125,-79.76300048828125 132.28900146484375,322.9419860839844 132.28900146484375,322.9419860839844 C132.28900146484375,322.9419860839844 323.3330078125,403 -15.722000122070312,422.3280029296875 C-217.22500610351562,433.81500244140625 -190.80599975585938,316.697998046875 -190.80599975585938,316.697998046875z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999856352806091,0.0053581353276968,-0.0053581353276968,0.9999856352806091,10.004150390625,-6.47021484375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,511.2130126953125,1298.552001953125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,228,181)",
    fillOpacity: 1,
    d: " M112.50199890136719,278.0790100097656 C112.50199890136719,278.0790100097656 -143.3159942626953,248.38499450683594 -143.3159942626953,248.38499450683594 C-141.81500244140625,238.6699981689453 -140.35400390625,228.9040069580078 -138.93499755859375,219.08599853515625 C-108.7239990234375,12.26099967956543 -61.66400146484375,-218.22799682617188 -5.830999851226807,-278.0790100097656 C-5.830999851226807,-278.0790100097656 143.3159942626953,-229.31700134277344 143.3159942626953,-229.31700134277344 C143.3159942626953,-229.31700134277344 112.50199890136719,278.0790100097656 112.50199890136719,278.0790100097656z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,572.280029296875,1068.3270263671875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,228,181)",
    fillOpacity: 1,
    d: " M81.69300079345703,9.482000350952148 C76.45600128173828,54.599998474121094 35.63600158691406,86.93000030517578 -9.482000350952148,81.69300079345703 C-54.599998474121094,76.45600128173828 -86.93000030517578,35.63600158691406 -81.69300079345703,-9.482000350952148 C-76.45600128173828,-54.599998474121094 -35.63600158691406,-86.93000030517578 9.482000350952148,-81.69300079345703 C54.599998474121094,-76.45600128173828 86.93000030517578,-35.63600158691406 81.69300079345703,9.482000350952148z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999856352806091,0.0053581353276968,-0.0053581353276968,0.9999856352806091,10.004150390625,-6.47021484375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,808.8330078125,1575.0899658203125)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,813.3049926757812,1321.0899658203125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,228,181)",
    fillOpacity: 1,
    d: " M302.8789978027344,363.75201416015625 C302.8789978027344,363.75201416015625 311.80999755859375,-276.6809997558594 311.80999755859375,-276.6809997558594 C310.510009765625,-308.1449890136719 276.59698486328125,-330.7070007324219 247.63299560546875,-340.0870056152344 C163.3699951171875,-367.375 -3.1700000762939453,-365.7239990234375 -3.1700000762939453,-365.7239990234375 C-3.1700000762939453,-365.7239990234375 -136.6199951171875,-361.9010009765625 -169.5749969482422,-356.42498779296875 C-193.7239990234375,-352.42999267578125 -222.14999389648438,-346.281005859375 -248.14500427246094,-337.16900634765625 C-276.822998046875,-327.07000732421875 -297.1570129394531,-296.9519958496094 -298.41400146484375,-265.4880065917969 C-298.41400146484375,-265.4880065917969 -305.9129943847656,87.87899780273438 -305.9129943847656,87.87899780273438 C-305.9129943847656,87.87899780273438 -311.80999755859375,365.7430114746094 -311.80999755859375,365.7430114746094 C-311.80999755859375,365.7430114746094 302.8789978027344,363.75201416015625 302.8789978027344,363.75201416015625z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,506.739013671875,1439.761962890625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M5.243000030517578,-247.07200622558594 C5.243000030517578,-247.07200622558594 0.652999997138977,-30.79199981689453 0.652999997138977,-30.79199981689453 C0.652999997138977,-30.79199981689453 -5.243000030517578,247.07200622558594 -5.243000030517578,247.07200622558594"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,781.177978515625,1116.1080322265625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M0,-83.98799896240234 C0,-83.98799896240234 0,83.98799896240234 0,83.98799896240234"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999578595161438,-0.009180302731692791,0.009180302731692791,0.9999578595161438,-5.526811599731445,8.85804271697998)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1139.030029296875,1302.008056640625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,228,181)",
    fillOpacity: 1,
    d: " M-81.7750015258789,279.1470031738281 C-81.7750015258789,279.1470031738281 168.39199829101562,218.0749969482422 168.39199829101562,218.0749969482422 C165.8280029296875,208.5850067138672 164.11099243164062,202.36900329589844 161.61700439453125,192.76800537109375 C108.76699829101562,-9.460000038146973 24.606000900268555,-201.7760009765625 -19.558000564575195,-279.1470031738281 C-19.558000564575195,-279.1470031738281 -168.39199829101562,-221.75 -168.39199829101562,-221.75 C-168.39199829101562,-221.75 -130.6439971923828,-3.4570000171661377 -130.6439971923828,-3.4570000171661377 C-130.6439971923828,-3.4570000171661377 -81.7750015258789,279.1470031738281 -81.7750015258789,279.1470031738281z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1017.031982421875,1348.551025390625)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M-23.25,-134.4499969482422 C-23.25,-134.4499969482422 23.25,134.4499969482422 23.25,134.4499969482422"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1052.2840576171875,1070.280029296875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,228,181)",
    fillOpacity: 1,
    d: " M-80.14800262451172,18.43899917602539 C-69.96399688720703,62.70399856567383 -25.826000213623047,90.33200073242188 18.43899917602539,80.14800262451172 C62.70399856567383,69.96399688720703 90.33200073242188,25.826000213623047 80.14800262451172,-18.43899917602539 C69.96399688720703,-62.70399856567383 25.826000213623047,-90.33200073242188 -18.43899917602539,-80.14800262451172 C-62.70399856567383,-69.96399688720703 -90.33200073242188,-25.826000213623047 -80.14800262451172,18.43899917602539z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999694228172302,0.007818995974957943,-0.007818995974957943,0.9999694228172302,12.382144927978516,-8.401042938232422)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,790.9390258789062,961.1119995117188)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,124,81)",
    fillOpacity: 1,
    d: " M66.48899841308594,0 C66.48899841308594,36.72100067138672 36.72100067138672,66.48899841308594 0,66.48899841308594 C-36.72100067138672,66.48899841308594 -66.48899841308594,36.72100067138672 -66.48899841308594,0 C-66.48899841308594,-36.72100067138672 -36.72100067138672,-66.48899841308594 0,-66.48899841308594 C36.72100067138672,-66.48899841308594 66.48899841308594,-36.72100067138672 66.48899841308594,0z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,790.9390258789062,876.7520141601562)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,124,81)",
    fillOpacity: 1,
    d: " M66.48899841308594,84.35900115966797 C66.48899841308594,84.35900115966797 -66.48899841308594,84.35900115966797 -66.48899841308594,84.35900115966797 C-66.48899841308594,84.35900115966797 -66.48899841308594,-84.35900115966797 -66.48899841308594,-84.35900115966797 C-66.48899841308594,-84.35900115966797 66.48899841308594,-84.35900115966797 66.48899841308594,-84.35900115966797 C66.48899841308594,-84.35900115966797 66.48899841308594,84.35900115966797 66.48899841308594,84.35900115966797z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,790.9390258789062,857.968994140625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    fillOpacity: 1,
    d: " M66.48899841308594,-2.871000051498413 C66.48899841308594,-2.871000051498413 24.757999420166016,46.29999923706055 -66.48899841308594,65.57599639892578 C-66.48899841308594,65.57599639892578 -66.48899841308594,-65.57599639892578 -66.48899841308594,-65.57599639892578 C-66.48899841308594,-65.57599639892578 66.48899841308594,-65.57599639892578 66.48899841308594,-65.57599639892578 C66.48899841308594,-65.57599639892578 66.48899841308594,-2.871000051498413 66.48899841308594,-2.871000051498413z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,16.345029830932617,-12.482913970947266)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,920.89501953125,750.5449829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,124,81)",
    fillOpacity: 1,
    d: " M51.65999984741211,0 C51.65999984741211,32.7130012512207 28.5310001373291,59.233001708984375 0,59.233001708984375 C-28.5310001373291,59.233001708984375 -51.65999984741211,32.7130012512207 -51.65999984741211,0 C-51.65999984741211,-32.7130012512207 -28.5310001373291,-59.233001708984375 0,-59.233001708984375 C28.5310001373291,-59.233001708984375 51.65999984741211,-32.7130012512207 51.65999984741211,0z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,922.14501953125,748.0440063476562)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M15.394000053405762,-18.190000534057617 C15.394000053405762,-18.190000534057617 -15.394000053405762,18.190000534057617 -15.394000053405762,18.190000534057617"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,664.52001953125,750.5449829101562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,124,81)",
    fillOpacity: 1,
    d: " M-51.65999984741211,0 C-51.65999984741211,32.7130012512207 -28.5310001373291,59.233001708984375 0,59.233001708984375 C28.5310001373291,59.233001708984375 51.65999984741211,32.7130012512207 51.65999984741211,0 C51.65999984741211,-32.7130012512207 28.5310001373291,-59.233001708984375 0,-59.233001708984375 C-28.5310001373291,-59.233001708984375 -51.65999984741211,-32.7130012512207 -51.65999984741211,0z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,655.9219970703125,748.0440063476562)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M-22.742000579833984,-18.190000534057617 C-22.742000579833984,-18.190000534057617 22.742000579833984,18.190000534057617 22.742000579833984,18.190000534057617"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,792.7769775390625,698.5440063476562)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,124,81)",
    fillOpacity: 1,
    d: " M145.718994140625,-35.1349983215332 C145.718994140625,-35.1349983215332 145.63800048828125,-32.665000915527344 145.31399536132812,-28.291000366210938 C145.15199279785156,-25.697999954223633 144.66600036621094,-22.417999267578125 143.93699645996094,-18.611000061035156 C143.3699951171875,-15.210000038146973 142.55999755859375,-11.402999877929688 141.7100067138672,-7.230000019073486 C140.94000244140625,-3.3420000076293945 140.08900451660156,0.828000009059906 139.197998046875,5.243000030517578 C137.9429931640625,11.763999938964844 136.64700317382812,18.770000457763672 135.593994140625,26.020000457763672 C131.3419952392578,55.9900016784668 112.02300262451172,102.44400024414062 100.35900115966797,124.1520004272461 C81.56700134277344,159.10299682617188 48.84299850463867,182.63400268554688 0,182.2689971923828 C-50.82699966430664,182.63400268554688 -81.5260009765625,159.10299682617188 -100.31800079345703,124.1520004272461 C-112.02300262451172,102.44400024414062 -131.30099487304688,56.03099822998047 -135.593994140625,26.059999465942383 C-135.593994140625,26.059999465942383 -135.593994140625,26.059999465942383 -135.593994140625,26.020000457763672 C-137.74000549316406,11.277000427246094 -140.7779998779297,-2.4509999752044678 -142.9250030517578,-13.144000053405762 C-144.13999938964844,-19.340999603271484 -145.0709991455078,-24.52400016784668 -145.31399536132812,-28.291000366210938 C-145.5970001220703,-32.665000915527344 -145.718994140625,-35.1349983215332 -145.718994140625,-35.1349983215332 C-145.718994140625,-35.1349983215332 -145.9219970703125,-55.54800033569336 -142.43899536132812,-75.2300033569336 C-141.1840057373047,-82.39900207519531 -139.48199462890625,-89.44599914550781 -137.052001953125,-95.39900207519531 C-128.22300720214844,-117.10700225830078 -98.33399963378906,-184.1750030517578 0,-182.2310028076172 C98.375,-184.1750030517578 128.26400756835938,-117.10700225830078 137.09300231933594,-95.39900207519531 C139.48199462890625,-89.44599914550781 141.2239990234375,-82.39900207519531 142.43899536132812,-75.2300033569336 C145.9219970703125,-55.54800033569336 145.718994140625,-35.1349983215332 145.718994140625,-35.1349983215332z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,792.7769775390625,620.4180297851562)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    fillOpacity: 1,
    d: " M145.718994140625,42.99100112915039 C145.718994140625,42.99100112915039 145.63800048828125,45.46099853515625 145.31399536132812,49.834999084472656 C145.15199279785156,52.428001403808594 144.66600036621094,55.70800018310547 143.93699645996094,59.51499938964844 C143.3699951171875,62.91600036621094 142.55999755859375,66.7229995727539 141.7100067138672,70.89600372314453 C140.94000244140625,74.78399658203125 140.08900451660156,78.95500183105469 139.197998046875,83.37000274658203 C140.00799560546875,74.54100036621094 140.45399475097656,65.63099670410156 139.80599975585938,59.474998474121094 C139.36099243164062,55.26300048828125 139.03599548339844,48.78200149536133 138.4290008544922,44.409000396728516 C137.01100158691406,33.959999084472656 137.01100158691406,25.17099952697754 134.54100036621094,14.96500015258789 C133.69000244140625,11.602999687194824 132.83999633789062,8.322999954223633 131.8679962158203,5.084000110626221 C130.16700744628906,-0.5870000123977661 128.26400756835938,-6.013999938964844 126.11699676513672,-10.954999923706055 C122.35099792480469,-19.540000915527344 118.30000305175781,-25.73699951171875 113.80500030517578,-30.070999145507812 C89.70700073242188,-53.68299865722656 54.229000091552734,-23.711999893188477 -1.8630000352859497,-25.25200080871582 C-46.6150016784668,-26.465999603271484 -84.36199951171875,-47.64699935913086 -109.22899627685547,-27.31599998474121 C-114.29100036621094,-23.184999465942383 -118.8270034790039,-17.35300064086914 -122.75599670410156,-9.293999671936035 C-123.8489990234375,-7.065999984741211 -124.86199951171875,-4.434000015258789 -125.75299835205078,-1.437000036239624 C-126.60299682617188,1.1950000524520874 -127.33300018310547,4.110000133514404 -128.02099609375,7.229000091552734 C-130.04600524902344,16.42300033569336 -131.54400634765625,27.358999252319336 -132.63800048828125,38.5359992980957 C-132.67799377441406,38.77899932861328 -132.677001953125,39.02199935913086 -132.71800231933594,39.26499938964844 C-132.71800231933594,39.26499938964844 -132.75900268554688,39.709999084472656 -132.75900268554688,39.709999084472656 C-134.2570037841797,55.50600051879883 -134.9459991455078,71.66500091552734 -135.31100463867188,83.85600280761719 C-135.31100463867188,83.85600280761719 -135.3509979248047,84.78700256347656 -135.3509979248047,84.78700256347656 C-135.63499450683594,95.88400268554688 -135.593994140625,103.45800018310547 -135.593994140625,104.14700317382812 C-137.74000549316406,89.40399932861328 -140.7779998779297,75.67500305175781 -142.9250030517578,64.98200225830078 C-144.13999938964844,58.78499984741211 -145.0709991455078,53.60200119018555 -145.31399536132812,49.834999084472656 C-145.5970001220703,45.46099853515625 -145.718994140625,42.99100112915039 -145.718994140625,42.99100112915039 C-145.718994140625,42.99100112915039 -145.9219970703125,22.57900047302246 -142.43899536132812,2.8970000743865967 C-141.1840057373047,-4.271999835968018 -139.48199462890625,-11.319000244140625 -137.052001953125,-17.27199935913086 C-128.22300720214844,-38.97999954223633 -98.33399963378906,-106.04900360107422 0,-104.1050033569336 C98.375,-106.04900360107422 128.26400756835938,-38.97999954223633 137.09300231933594,-17.27199935913086 C139.48199462890625,-11.319000244140625 141.2239990234375,-4.271999835968018 142.43899536132812,2.8970000743865967 C145.9219970703125,22.57900047302246 145.718994140625,42.99100112915039 145.718994140625,42.99100112915039z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,784.1019897460938,735.2960205078125)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M4.445000171661377,-34.422000885009766 C4.445000171661377,-34.422000885009766 -6.10099983215332,-5.2729997634887695 -4.2829999923706055,11.706000328063965 C-2.4649999141693115,28.684999465942383 14.628999710083008,34.422000885009766 14.628999710083008,34.422000885009766"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,808.281005859375,757.1409912109375)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M-3.003999948501587,-4.633999824523926 C-3.003999948501587,-4.633999824523926 4.633999824523926,4.633999824523926 4.633999824523926,4.633999824523926"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,793.6929931640625,770.4559936523438)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    fillOpacity: 1,
    d: " M143.82699584960938,-95.18199920654297 C143.82699584960938,-89.1520004272461 141.60299682617188,-72.42900085449219 139.8209991455078,-60.27899932861328 C135.56900024414062,-30.30900001525879 111.12100219726562,30.51300048828125 99.45700073242188,52.22100067138672 C80.66500091552734,87.1719970703125 47.941001892089844,110.7030029296875 -0.9020000100135803,110.33799743652344 C-51.729000091552734,110.7030029296875 -82.42900085449219,87.1719970703125 -101.22100067138672,52.22100067138672 C-112.9260025024414,30.51300048828125 -132.2030029296875,-15.9399995803833 -136.49600219726562,-45.90999984741211 C-138.64199829101562,-60.65299987792969 -141.67999267578125,-74.38099670410156 -143.82699584960938,-85.0739974975586 C-143.82699584960938,-85.0739974975586 -134.91700744628906,-94.3479995727539 -134.91700744628906,-94.3479995727539 C-134.91700744628906,-94.3479995727539 -129.17300415039062,-58.435001373291016 -129.17300415039062,-58.435001373291016 C-121.26100158691406,-17.988000869750977 -119.72899627685547,-0.5099999904632568 -98.79100036621094,20.42799949645996 C-93.56700134277344,25.61199951171875 -88.50399780273438,29.500999450683594 -84.2509994506836,30.715999603271484 C-73.96399688720703,33.5099983215332 -54.11899948120117,19.20800018310547 -36.21799850463867,12.121000289916992 C-13.17300033569336,3.007999897003174 12.503000259399414,3.0889999866485596 35.345001220703125,12.727999687194824 C50.492000579833984,19.167999267578125 66.73300170898438,32.70000076293945 75.52100372314453,30.715999603271484 C82.9729995727539,29.014999389648438 93.26000213623047,19.739999771118164 102.65599822998047,9.45300006866455 C118.37000274658203,-7.677999973297119 122.052001953125,-24.433000564575195 127.2020034790039,-47.145999908447266 C130.5749969482422,-62.020999908447266 139.7740020751953,-110.34200286865234 139.7740020751953,-110.34200286865234 C139.7740020751953,-110.34200286865234 143.82699584960938,-95.18199920654297 143.82699584960938,-95.18199920654297z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,16.345029830932617,-12.482913970947266)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,862.7329711914062,709.9110107421875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillOpacity: 1,
    d: " M-48.17499923706055,21.01300048828125 C-48.17499923706055,21.01300048828125 -43.275001525878906,-16.360000610351562 -11.729999542236328,-29.60300064086914 C19.815000534057617,-42.84600067138672 48.17499923706055,-20.660999298095703 48.17499923706055,-20.660999298095703 C48.17499923706055,-20.660999298095703 45.62099838256836,15.958000183105469 10.684000015258789,29.434999465942383 C-24.253000259399414,42.9119987487793 -48.17499923706055,21.01300048828125 -48.17499923706055,21.01300048828125z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_40_1)",
    style: {
      display: "block"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,16.345029830932617,-12.482913970947266)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,862.7329711914062,710.0670166015625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    fillOpacity: 1,
    d: " M32.202999114990234,0 C32.202999114990234,17.78499984741211 17.78499984741211,32.202999114990234 0,32.202999114990234 C-17.78499984741211,32.202999114990234 -32.202999114990234,17.78499984741211 -32.202999114990234,0 C-32.202999114990234,-17.78499984741211 -17.78499984741211,-32.202999114990234 0,-32.202999114990234 C17.78499984741211,-32.202999114990234 32.202999114990234,-17.78499984741211 32.202999114990234,0z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,16.345029830932617,-12.482913970947266)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,722.6810302734375,709.9110107421875)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillOpacity: 1,
    d: " M48.17499923706055,21.01300048828125 C48.17499923706055,21.01300048828125 43.275001525878906,-16.360000610351562 11.729999542236328,-29.60300064086914 C-19.815000534057617,-42.84600067138672 -48.17499923706055,-20.660999298095703 -48.17499923706055,-20.660999298095703 C-48.17499923706055,-20.660999298095703 -45.62099838256836,15.958000183105469 -10.684000015258789,29.434999465942383 C24.253000259399414,42.9119987487793 48.17499923706055,21.01300048828125 48.17499923706055,21.01300048828125z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__lottie_element_31_1)",
    style: {
      display: "block"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,16.345029830932617,-12.482913970947266)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,722.6810302734375,710.0670166015625)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    fillOpacity: 1,
    d: " M-32.202999114990234,0 C-32.202999114990234,17.78499984741211 -17.78499984741211,32.202999114990234 0,32.202999114990234 C17.78499984741211,32.202999114990234 32.202999114990234,17.78499984741211 32.202999114990234,0 C32.202999114990234,-17.78499984741211 17.78499984741211,-32.202999114990234 0,-32.202999114990234 C-17.78499984741211,-32.202999114990234 -32.202999114990234,-17.78499984741211 -32.202999114990234,0z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9855678677558899,0.16928069293498993,-0.16928069293498993,0.9855678677558899,130.2067108154297,-138.2144317626953)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,864.2429809570312,649.31201171875)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M-46.77799987792969,10.079000473022461 C-46.77799987792969,10.079000473022461 1.7649999856948853,-31.844999313354492 46.77799987792969,5.224999904632568"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9840282201766968,-0.17801223695278168,0.17801223695278168,0.9840282201766968,-96.38510131835938,135.4799041748047)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,720.4849853515625,650.0349731445312)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M46.77799987792969,10.079000473022461 C46.77799987792969,10.079000473022461 -1.7649999856948853,-31.844999313354492 -46.77799987792969,5.224999904632568"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,812.3508911132812,794.0272827148438)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M-18.7189998626709,6.935999870300293 C-18.7189998626709,6.935999870300293 11.767999649047852,10.093000411987305 18.7189998626709,-7.163000106811523"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999151825904846,0.013019788078963757,-0.013019788078963757,0.9999151825904846,16.345029830932617,-12.482913970947266)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,792.7069702148438,888.14599609375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(239,228,181)",
    fillOpacity: 1,
    d: " M0,-419.8909912109375 C-89.26100158691406,-419.71099853515625 -179.24899291992188,-371.4649963378906 -210.96200561523438,-264.375 C-268.239013671875,-70.95999908447266 -470.10699462890625,339.8869934082031 -470.10699462890625,339.8869934082031 C-470.10699462890625,339.8869934082031 -400.9320068359375,392.59600830078125 -165.9980010986328,419.8909912109375 C-165.9980010986328,419.8909912109375 -134.25,-264.8080139160156 -134.25,-264.8080139160156 C-134.25,-264.8080139160156 0,-264.8080139160156 0,-264.8080139160156 C0,-264.8080139160156 134.25,-264.8080139160156 134.25,-264.8080139160156 C134.25,-264.8080139160156 165.9980010986328,419.8909912109375 165.9980010986328,419.8909912109375 C400.9320068359375,392.59600830078125 470.10699462890625,339.8869934082031 470.10699462890625,339.8869934082031 C470.10699462890625,339.8869934082031 268.239013671875,-70.95999908447266 210.96200561523438,-264.375 C179.24899291992188,-371.4649963378906 89.26100158691406,-419.71099853515625 0,-419.8909912109375"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,1094.885986328125,965.68701171875)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M167.92799377441406,262.34600830078125 C167.92799377441406,262.34600830078125 98.75299835205078,315.0539855957031 -136.18099975585938,342.3489990234375 C-136.18099975585938,342.3489990234375 -167.92799377441406,-342.3489990234375 -167.92799377441406,-342.3489990234375"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,490.52899169921875,965.68701171875)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(2,2,2)",
    strokeOpacity: 1,
    strokeWidth: 1.7,
    d: " M-167.92799377441406,262.34600830078125 C-167.92799377441406,262.34600830078125 -98.75299835205078,315.0539855957031 136.18099975585938,342.3489990234375 C136.18099975585938,342.3489990234375 167.92799377441406,-342.3489990234375 167.92799377441406,-342.3489990234375"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,799.0650024414062,623.3380126953125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(2,2,2)",
    fillOpacity: 1,
    d: " M223.3090057373047,26.902999877929688 C223.3090057373047,26.902999877929688 -223.3090057373047,26.902999877929688 -223.3090057373047,26.902999877929688 C-238.16700744628906,26.902999877929688 -250.21200561523438,14.857999801635742 -250.21200561523438,0 C-250.21200561523438,0 -250.21200561523438,0 -250.21200561523438,0 C-250.21200561523438,-14.857999801635742 -238.16700744628906,-26.902999877929688 -223.3090057373047,-26.902999877929688 C-223.3090057373047,-26.902999877929688 223.3090057373047,-26.902999877929688 223.3090057373047,-26.902999877929688 C238.16700744628906,-26.902999877929688 250.21200561523438,-14.857999801635742 250.21200561523438,0 C250.21200561523438,0 250.21200561523438,0 250.21200561523438,0 C250.21200561523438,14.857999801635742 238.16700744628906,26.902999877929688 223.3090057373047,26.902999877929688z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePhotoPlaceholder);
export default __webpack_public_path__ + "static/media/profile-photo-placeholder.ac64a4dfb88445af4bc003a6bcbdaa6d.svg";
export { ForwardRef as ReactComponent };